import { canUseHtmlDialogElement } from "../../../../common/utils/canUseHtmlDialogElement";
import { getNextParentElement } from "../../../../common/utils/getNextParentElement";

/**
 *
 *
 *
 *
 *
 */
export function teleportHost(Host: HTMLElement, floaterTarget: HTMLElement | undefined): void {
  if (!canUseHtmlDialogElement) return;
  if (!floaterTarget) return;

  let parent: HTMLElement | null | undefined = floaterTarget;
  while ((parent = getNextParentElement(parent))) {
    if (parent?.tagName === "DIALOG") {
      if (Host.parentElement !== parent) {
        Host.style.position = "absolute";
        parent.append(Host);
      }
      return;
    }
  }
  if (Host.parentElement !== document.body) {
    document.body.append(Host);
  }
}
